export default {
  'order.CopiedSuccessfully': '已成功複製!',
  'order.ReplicationIsNotSupported': '不支持複製',
  'order.YourApplicationHasBeenSuccessfulPleaseCheckTheOrderStatusLater':
    '您的申請已成功，請稍後查看訂單狀態',
  'order.TheSystemIsDeserted': '系統開小差啦！',
  'order.ParameterError': '參數錯誤!',
  'order.TransferToBePaid': '轉單待付款',
  'order.OrderHasBeenTransferred': '已轉單',
  'order.SignUpAndPayNow': '立即簽約支付',
  'order.ApplyForADeduction': '申請扣款',
  'order.growBeans': '成長豆',
  'order.MyShippingAddress': '我的收貨地址',
  'order.LogisticsInformation': '物流信息：',
  'order.openRecord': '開通記錄',
  'order.callOfficial': '叫叫官方',
  'order.CheckRefund': '查看退款',
  'order.TotalEquityPayable': '權益應付總額',
  'order.totalPrice': '商品總價',
  'order.freight': '運費',
  'order.AmountToBeCarriedForward': '轉單結轉金額',
  'order.transferFee': '轉單費用',
  'order.TransferDiscount': '轉單優惠',
  'order.FirstInstallmentDiscount': '優惠抵扣',
  'order.CompensationDiscounts': '補差優惠抵扣',
  'order.DeductionInstructions': '扣費說明',
  'order.Payable': '應付款：',
  'order.realPayment': '實付款：',
  'order.toPay': '去支付',
  'order.SubscriptionPay': '訂閱實付',
  'order.PayForUpgrade': '升級實付',
  'order.coupon': '優惠券',
  'order.orderNumber': '訂單編號',
  'order.copy': '複製',
  'order.orderTime': '下單時間',
  'order.paymentMethod': '支付方式',
  'order.PaymentTime': '支付時間',
  'order.Ship': '發貨',
  'order.deliveryTime': '發貨時間',
  'order.TransferOrderType': '轉單類型',
  'order.transferToYourself': '轉給自己',
  'order.transferToOthers': '轉給其他人',
  'order.TransferOrderObject': '轉單對象',
  'order.TurnoverTime': '轉單時間',
  'order.UpgradeInformation': '升級信息',
  'order.hint': '提示',
  'order.understood': '知道了',
  'order.ToPayForTheOrderPleasePayInTheOrderLogisticsOfTheCallOfficialAccount':
    '支付該訂單請在【叫叫】公眾號的訂單物流中進行支付',
  'order.PleaseEnsureThatYourContractAccountBalanceIsSufficientBeforeMakingADeductionApplication':
    '請保障您的簽約賬戶餘額充足後再進行扣款申請',
  'order.Cancel': '取消'
};
